export enum InjectionMoldingProductBillOfMaterialsLineItemType {
    Component = 'Component',
    Material = 'Material',
}
